export const EMAILJS_CONFIG = {
    SERVICE_ID: process.env.REACT_APP_EMAILJS_SERVICE_ID,
    TEMPLATE_ID: process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
    PUBLIC_KEY: process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
};

export const SOCIAL_LINKS = [
    {
        icon: 'FaGithub',
        url: 'https://github.com/k0laa',
        label: 'GitHub',
    },
    {
        icon: 'FaLinkedin',
        url: 'https://linkedin.com/in/bugrayalcin8',
        label: 'LinkedIn',
    },
    {
        icon: 'FaInstagram',
        url: 'https://instagram.com/___kolaa___',
        label: 'Instagram',
    },
]; 